export const LAYOUT_TXT = {
  en: {
    helpCenter: "Handle Docs",
    searchArticles: "Search articles…",
    searchShort: "Search…",
    support: "Support",
    askAi: "Ask AI",
    contactSupport: "Contact Support",
    loading: "Loading…",
    spaceNotFound: "Help center not found",
    spaceNotFoundDesc: "This space may be unpublished or doesn't exist.",
    poweredBy: "Powered by",
    switchLight: "Switch to light",
    switchDark: "Switch to dark",
    voiceAi: "Voice AI",
    menu: "Menu",
    searching: "Searching…",
    viewAllResults: "View all results",
    searchHint: "Type at least 2 characters to search in English and Arabic…",
    noResults: "No results for",
    switchLangHint: "Opens in this language",
  },
  ar: {
    helpCenter: "Handle Docs",
    searchArticles: "ابحث في المقالات…",
    searchShort: "ابحث…",
    support: "الدعم",
    askAi: "اسأل AI",
    contactSupport: "تواصل مع الدعم",
    loading: "جاري التحميل…",
    spaceNotFound: "مركز المساعدة غير موجود",
    spaceNotFoundDesc: "قد يكون هذا المركز غير منشور أو غير موجود.",
    poweredBy: "مدعوم من",
    switchLight: "التبديل إلى الوضع الفاتح",
    switchDark: "التبديل إلى الوضع الداكن",
    voiceAi: "صوت AI",
    menu: "القائمة",
    searching: "جاري البحث…",
    viewAllResults: "عرض كل النتائج",
    searchHint: "اكتب حرفين على الأقل للبحث بالإنجليزية والعربية…",
    noResults: "لا توجد نتائج لـ",
    switchLangHint: "يفتح بهذه اللغة",
  },
};

const NAV_LABEL_AR = {
  website: "الموقع",
  "contact us": "تواصل معنا",
  contact: "تواصل",
  home: "الرئيسية",
  documentation: "التوثيق",
  docs: "التوثيق",
  blog: "المدونة",
  pricing: "الأسعار",
  about: "من نحن",
  support: "الدعم",
  login: "تسجيل الدخول",
  "sign in": "تسجيل الدخول",
  dashboard: "لوحة التحكم",
};

export function translateNavLinkLabel(link, lang) {
  if (!link?.label) return "";
  if (lang !== "ar") return link.label;
  if (link.label_ar) return link.label_ar;
  return NAV_LABEL_AR[link.label.trim().toLowerCase()] || link.label;
}

export const ARTICLE_TXT = {
  en: {
    loading: "Loading…",
    home: "Home",
    anonymous: "Anonymous",
    minRead: "min read",
    updated: "Updated",
    helpfulQ: "Was this article helpful?",
    yes: "Yes",
    no: "No",
    thanks: "Thanks for your feedback!",
    thanksImprove: "Thanks — we'll improve this article.",
    feedbackMsg: "What could we improve?",
    feedbackPlaceholder: "Optional feedback…",
    sendFeedback: "Send feedback",
    share: "Share",
    copyLink: "Copy link",
    linkCopied: "Link copied",
    tweet: "Tweet",
    shareLinkedin: "Share",
    related: "Related articles",
    backTo: "Back to",
    onThisPage: "On this page",
  },
  ar: {
    loading: "جاري التحميل…",
    home: "الرئيسية",
    anonymous: "مجهول",
    minRead: "دقائق قراءة",
    updated: "آخر تحديث",
    helpfulQ: "هل كانت هذه المقالة مفيدة؟",
    yes: "نعم",
    no: "لا",
    thanks: "شكراً على ملاحظاتك!",
    thanksImprove: "شكراً — سنعمل على تحسين هذه المقالة.",
    feedbackMsg: "ما الذي يمكن تحسينه؟",
    feedbackPlaceholder: "ملاحظات اختيارية…",
    sendFeedback: "إرسال الملاحظات",
    share: "مشاركة",
    copyLink: "نسخ الرابط",
    linkCopied: "تم نسخ الرابط",
    tweet: "تغريد",
    shareLinkedin: "مشاركة",
    related: "مقالات ذات صلة",
    backTo: "العودة إلى",
    onThisPage: "في هذه الصفحة",
  },
};

export const SEARCH_TXT = {
  en: {
    placeholder: "Search articles…",
    enterTerm: "Enter a search term to begin.",
    searching: "Searching…",
    noResults: "No results for",
    noResultsHint: "Try different keywords or browse categories from the home page.",
    result: "result",
    results: "results",
    for: "for",
    minRead: "min read",
  },
  ar: {
    placeholder: "ابحث في المقالات…",
    enterTerm: "أدخل كلمة بحث للبدء.",
    searching: "جاري البحث…",
    noResults: "لا توجد نتائج لـ",
    noResultsHint: "جرّب كلمات مختلفة أو تصفح الفئات من الصفحة الرئيسية.",
    result: "نتيجة",
    results: "نتائج",
    for: "لـ",
    minRead: "دقائق قراءة",
  },
};

export function pickLang(lang) {
  return lang === "ar" ? "ar" : "en";
}

export function layoutT(lang) {
  return LAYOUT_TXT[pickLang(lang)];
}

export function articleT(lang) {
  return ARTICLE_TXT[pickLang(lang)];
}

export function searchT(lang) {
  return SEARCH_TXT[pickLang(lang)];
}

export function applyArticleLang(article, lang) {
  if (!article || !lang || lang === "en") return article;
  const tr = article.i18n?.[lang];
  if (!tr) return article;
  return {
    ...article,
    ...(tr.title ? { title: tr.title } : {}),
    ...(tr.content ? { content: tr.content } : {}),
    ...(tr.excerpt ? { excerpt: tr.excerpt } : {}),
    category: article.category ? applyCategoryLang(article.category, lang) : article.category,
  };
}

export function applyCategoryLang(category, lang) {
  if (!category || !lang || lang === "en") return category;
  const tr = category.i18n?.[lang];
  if (!tr) return category;
  return {
    ...category,
    ...(tr.name ? { name: tr.name } : {}),
    ...(tr.description ? { description: tr.description } : {}),
  };
}
